import React from "react";
import { useTranslation } from "react-i18next";

//Material-UI Core Components
import Box from '@mui/material/Box';

//Custom Components
import AdminTasksForm from "./AdminTasksForm";
import AppPage from "@/ui/AppPage/AppPage";


function AdminTasksPage() {

  return (
    <AppPage>
      <Box m={2}>
        <AdminTasksForm />
      </Box>
    </AppPage>
  );
}

export default AdminTasksPage;
